import { memo, useCallback, useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";

import AddIcon from "@mui/icons-material/Add";
import CloseIcon from "@mui/icons-material/Close";
import InsertInvitationIcon from "@mui/icons-material/InsertInvitation";
import { LoadingButton } from "@mui/lab";
import {
  Autocomplete,
  Box,
  Checkbox,
  Grid,
  IconButton,
  InputAdornment,
  Modal,
  Stack,
  TextField,
  Typography
} from "@mui/material";
import { LocalizationProvider, MobileDatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { debounce } from "lodash";

import dayjs from "dayjs";
import { Fileuploadrequestcall } from "../../request/Fileuploadrequest";
import { Getrequestcall } from "../../request/Getrequest";
import { Postrequestcall } from "../../request/Postrequest";
import { BILightGrey } from "../../assets/helpers";
import PictureViewer from "../../common/PictureViewer";
import {
  DELETE_SAFETY_OBS_PICTURE,
  FETCH_CLIENT_EMP_JOBS,
  FETCH_CLIENT_TIMESHEET_UD_FIELDS_NEW,
  SAVE_CLIENT_SAFETY_OBS,
  SAVE_CLIENT_SAFETY_OBS_PICTURES,
  SAVE_CLIENT_UD_FIELDS_VALUES
} from "../../constant/Apipath";
import { ClientEnglishFallback } from "../constant/ClientEnglishFallback";
import { English } from "../../constant/EnglishFallback";
import TodayDatePicker from "../component/TodayDatePicker";
import { ClientUDFieldComponent } from "./ClientUDFieldComponent";

export default function ClientSafetyObservationAddModal({
  isOpen,
  onClose,
  data,
  setData,
  from,
  mode,
  reLoadData,
  SARid
}) {

  const hint = useRef("");
  const imgRef = useRef(null);

  const [loading, setLoading] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [description, setDescription] = useState("");
  const [pictureViewerOpen, setPictureViewerOpen] = useState(false);
  const [imageIndex, setImageIndex] = useState(0);

  const [clientJobList, setClientJobList] = useState([]);
  const [clientUDFields, setClientUDFields] = useState([]);
  const [selectedValue, setSelectedValue] = useState(null);
  const [deleteImageList, setDeleteImageList] = useState([]);
  const [uploadedImageList, setUploadedImageList] = useState([]);
  const [safetyObservationDate, setSafetyObservationDate] = useState(dayjs());
  const { loginData, selectedClientData, multiLanguageData } = useSelector((state) => state?.main);

  const CLIENT_ACCENT_COLOR = selectedClientData?.AccentColor;
  const TOKEN = loginData?.accessToken;
  const USER_ID = loginData?.userInformation?.UserId;
  const LANGUAGE = ClientEnglishFallback.ClientSafetyObservationAddModal(
    multiLanguageData?.ClientSafetyObservationAddModal || {}
  );
  const {
    TEXT_DATE,
    TEXT_JOB,
    TEXT_DESCRIPTION,
    TEXT_PROBLEM_NEEDS_DONE,
    BUTTON_SUBMIT,
    TEXT_SEARCH_JOB
  } = LANGUAGE;

  const { TEXT_NO_OPTIONS = English?.AddExperience?.TEXT_NO_OPTIONS } =
    multiLanguageData?.AddExperience || {};

  // useEffect(() => {
  //   if (isOpen) {
  //     getData();
  //   }
  // }, [inputValue, isOpen]);

  const getData = useCallback(
    debounce(async (flag) => {
      await getClientJobs(flag);
    }, 500),
    []
  );

  useEffect(() => {
    if (isOpen) {
      // getClientJobs();
      getData()

      if (from === "SAR") {
        setInputValue(`${data?.jobCode} - ${data?.jobName}`);
        setSelectedValue({
          clientEmployeeId: data?.clientEmployeeId,
          clientJobCodeId: data?.clientJobId
        });
        getUDfields("", data?.clientJobId);
      }
      if (mode === "edit") {
        setInputValue(`${data?.clientJobCode} - ${data?.clientJobName}`);
        setSafetyObservationDate(dayjs(data?.safetyObservationDate));
        setDescription(data?.description);
        setUploadedImageList([...data?.pictureList]);
        setSelectedValue({
          clientEmployeeId: data?.clientEmployeeId,
          clientJobCodeId: data?.clientJobId
        });
        let ud = data?.udFieldsList?.map((field) => {
          return {
            ...field,
            fieldDefaultValue: field.value === "true" ? true : false,
            value: field.value
          };
        });
        setClientUDFields(ud);
      }
    }
  }, [isOpen]);

  const getClientJobs = async (input) => {
    try {
      const obj = {
        PageNr: 1,
        NrOfRecPerPage: 20,
        FullSearch: input ?? inputValue,
        UserId: USER_ID,
        IncludeRecordNr: true,
        FetchAllowedRecordsOnly: true,
        SearchList: [
          {
            clientEmployeeId: selectedClientData?.ClientEmployeeId,
            ClientId: selectedClientData?.ClientId,
            active: true
          }
        ],
        SortList: [{ FieldName: "dateModified", Direction: "DESC" }]
      };
      let clientJobRes = await Postrequestcall(FETCH_CLIENT_EMP_JOBS, obj, TOKEN);
      let data = clientJobRes?.data?.data;
      if (Array.isArray(data) && data?.length > 0) {
        data.forEach((obj) => {
          if (obj.jobCode) {
            obj.label = obj.jobCode;
          }
        });
        setClientJobList(data);
      }
    } catch (error) {
      console.error("getClientJobs Error ", error);
    }
  };

  const getUDfields = async (clientJOBid, entityRecordId) => {
    let appId = 4; // Using default 4 or selected app ID
    let clientId = selectedClientData?.ClientId;

    // Fallback if we have observationAppID passed in data
    if (from === "SAR" && data?.observationAppID) {
      appId = data.observationAppID;
    }

    try {
      let payload = {
        ClientId: clientId,
        JobList: entityRecordId ? entityRecordId.toString() : "",
        EmployeeId: "",
        ActivityId: "",
      };

      let res = await Postrequestcall(FETCH_CLIENT_TIMESHEET_UD_FIELDS_NEW, payload, TOKEN);
      let rawData = res?.data?.data;
      let udFields = [];
      if (Array.isArray(rawData)) {
        udFields = rawData;
      } else if (rawData && typeof rawData === "object") {
        udFields = [
          ...(rawData.jobUdFields || []),
          ...(rawData.employeeUdFields || []),
          ...(rawData.activityUdFields || [])
        ];
      }
      setClientUDFields(udFields);
    } catch (error) {
      console.error("getUDfields Error ", error);
    }
  };

  const handleSafetyObservationSubmit = async () => {
    try {
      setLoading(true);
      if (deleteImageList?.length > 0) {
        const deletePromises = deleteImageList?.map(async (item) => {
          const deletePicObj = {
            UserId: USER_ID,
            ReturnRecordId: true,
            ReturnRecordError: true,
            SoftDelete: true,
            DeleteList: [{ Id: item.id }]
          };

          await Postrequestcall(DELETE_SAFETY_OBS_PICTURE, deletePicObj, TOKEN);
        });
        await Promise.all(deletePromises);
      }
      let obj = {
        UserId: USER_ID,
        ReturnRecordId: true,
        ReturnRecordError: true,
        SaveList: [
          {
            Id: mode === "ADD" ? 0 : data?.id,
            ClientEmployeeId: Number(selectedValue?.clientEmployeeId),
            SafetyObservationDate: dayjs(safetyObservationDate).toISOString(),
            ClientJobId: Number(selectedValue?.clientJobCodeId),
            Description: description,
            SARId: from === "SAR" ? SARid : 0,
            isUDField: (mode === "edit" ? data?.udFieldsList?.length > 0 : clientUDFields?.length > 0) ? true : false,
            ModifiedBy: USER_ID
          }
        ]
      };
      const res = await Postrequestcall(SAVE_CLIENT_SAFETY_OBS, obj, TOKEN);
      if (res?.status === 201 || res?.status === 200) {
        let obsId = mode === "ADD" ? res?.data?.data?.[0]?.objData?.id : data?.id;

        let udSaveList = [];
        if (mode === "edit") {
          data?.udFieldsList?.forEach((field) => {
            const valStr = field.value !== undefined ? field.value.toString() : "";
            if (valStr.trim() !== "") {
              udSaveList.push({
                Id: field.recordId || field.id || 0,
                ClientId: selectedClientData?.ClientId,
                ClientEmployeeId: Number(selectedValue?.clientEmployeeId),
                AppId: field.appId || (from === "SAR" && data?.observationAppID ? data?.observationAppID : 4),
                AppRecordId: obsId,
                AppEntityId: field.appEntityId || 6,
                EntityRecordId: field.entityRecordId || 0,
                UDFieldId: field.udFieldId || field.id,
                Value: valStr,
                ModifiedBy: USER_ID
              });
            }
          });
        } else {
          clientUDFields.forEach((field) => {
            const valStr = field.fieldDefaultValue !== undefined ? field.fieldDefaultValue.toString() : "";
            if (valStr.trim() !== "") {
              udSaveList.push({
                Id: 0,
                ClientId: selectedClientData?.ClientId,
                ClientEmployeeId: Number(selectedValue?.clientEmployeeId),
                AppId: from === "SAR" && data?.observationAppID ? data?.observationAppID : 4,
                AppRecordId: obsId,
                AppEntityId: field.appEntityId || 6,
                EntityRecordId: field.entityRecordId || 0,
                UDFieldId: field.id,
                Value: valStr,
                ModifiedBy: USER_ID
              });
            }
          });
        }

        if (udSaveList.length > 0) {
          const udPayload = {
            UserId: USER_ID,
            ReturnRecordId: true,
            ReturnRecordError: true,
            SaveList: udSaveList
          };
          await Postrequestcall(SAVE_CLIENT_UD_FIELDS_VALUES, udPayload, TOKEN);
        }

        if (uploadedImageList?.length > 0) {
          const uploadPromises = uploadedImageList?.map(async (picture) => {
            if (picture.id) {
              return Promise.resolve();
            }
            const formData = new FormData();
            formData.append("Id", 0);
            formData.append("SafetyObservationId", obsId);
            formData.append("ModifiedBy", USER_ID);
            formData.append("FileName", picture);
            await Fileuploadrequestcall(SAVE_CLIENT_SAFETY_OBS_PICTURES, formData, TOKEN);
          });
          await Promise.all(uploadPromises);
        }
        onClose();
        resetData();
        setDescription("");
      }
      setLoading(false);
    } catch (error) {
      console.error("handleSafetyObservationSubmit-> Error ", error);
    } finally {
      setLoading(false);
      resetData();
      reLoadData();
    }
  };

  const handleUDFieldChange = (id, value, type) => {
    if (mode === "edit") {
      const newData = data?.udFieldsList?.map((field) => {
        if (field.id === id || field.udFieldId === id) {
          return {
            ...field,
            value: value
          };
        } else {
          return field;
        }
      });
      setData({
        ...data,
        udFieldsList: newData
      });
    } else {
      setClientUDFields((prev) => {
        return prev?.map((field) => {
          if (field.id === id || field.udFieldId === id) {
            return {
              ...field,
              value: value,
              fieldDefaultValue: value
            };
          }
          return field;
        });
      });
    }
  };

  const handleAddImage = () => {
    imgRef.current.click();
  };

  // const handleImageChange = (event) => {
  //   let temp = [...uploadedImageList];
  //   let files = event.target.files;
  //   for (let i = 0; i < files?.length; i++) {
  //     temp.push(files[i]);
  //   }
  //   setUploadedImageList(temp);
  //   event.target.value = "";
  // };
  const handleImageChange = (event) => {
    let temp = [...uploadedImageList];
    let files = event.target.files;
    for (let i = 0; i < files?.length; i++) {
      const file = files[i];
      if (file.type && file.type.startsWith("image/")) {
        temp.push(file);
      } else {
        alert("Only image files are allowed.");
      }
    }
    setUploadedImageList(temp);
    event.target.value = "";
  };
  const handleRemoveImage = useCallback(
    (picture, index) => {
      const deleteList = [...deleteImageList];
      if (picture.id) {
        deleteList.push({ id: picture?.id });
      }
      setDeleteImageList(deleteList);
      let temp = [...uploadedImageList];
      temp.splice(index, 1);
      setUploadedImageList(temp);
    },
    [uploadedImageList, deleteImageList]
  );

  const resetData = () => {
    setInputValue("");
    setSelectedValue(null);
    setUploadedImageList([]);
    setDeleteImageList([]);
    setDescription("");
    setSafetyObservationDate(null);
    setClientUDFields([]);
  };

  return (
    <>
      <Modal
        open={isOpen}
        onClose={() => {
          resetData();
          onClose();
        }}>
        <div className="client-modal-responsive">
          <div className="action-button-container">
            <IconButton
              onClick={() => {
                resetData();
                onClose();
              }}
              sx={{
                color:
                  selectedClientData?.AccentColor !== undefined && selectedClientData?.AccentColor
                    ? selectedClientData?.AccentColor
                    : BILightGrey
              }}>
              <CloseIcon />
            </IconButton>
          </div>
          <Stack
            sx={{
              padding: {
                xs: 0,
                sm: 0,
                md: 0.5,
                lg: 0.5,
                xl: 1
              }
            }}>
            <Grid container sx={{ display: "flex", flexDirection: "column" }}>
              <Grid>
                <TodayDatePicker
                  date={safetyObservationDate}
                  label={TEXT_DATE}
                  setDate={setSafetyObservationDate}
                />
              </Grid>
              <Grid>
                <Typography sx={{ margin: 0 }} variant="subtitle1" gutterBottom>
                  {TEXT_JOB}
                </Typography>
                <Autocomplete
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0",
                      padding: "0"
                    },
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                      border: "none"
                    }
                  }}
                  size="small"
                  noOptionsText={TEXT_NO_OPTIONS}
                  style={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px"
                  }}
                  fullWidth
                  onKeyDown={(event) => {
                    if (event.key === "Tab") {
                      if (hint.current) {
                        setInputValue(hint.current);
                        event.preventDefault();
                      }
                    }
                  }}
                  onBlur={() => {
                    hint.current = "";
                  }}
                  disablePortal
                  inputValue={inputValue}
                  filterOptions={(options, state) => {
                    const displayOptions = options.filter(
                      (option) =>
                        option?.label
                          .toLowerCase()
                          .includes(state?.inputValue?.toLowerCase()?.trim()) ||
                        (option.name &&
                          option.name
                            .toLowerCase()
                            .includes(state?.inputValue?.toLowerCase().trim()))
                    );

                    return displayOptions;
                  }}
                  id="combo-box-hint-demo"
                  options={clientJobList}
                  renderOption={(props, option) => {
                    const { key, ...restProps } = props; // Extract the `key` from props
                    return (
                      <Box key={key} {...restProps}>
                        <Typography>{`${option?.label} - ${option?.name}`}</Typography>
                      </Box>
                    );
                  }}
                  onChange={(event, newValue, reason) => {
                    if (reason === "clear") {
                      setSelectedValue(null);
                      setInputValue("");
                      setClientUDFields([]);
                    } else {
                      if (newValue) {
                        getUDfields(newValue?.clientId, newValue?.id);
                        setSelectedValue({
                          clientEmployeeId: selectedClientData?.ClientEmployeeId,
                          clientJobCodeId: newValue?.id
                        });
                        if (newValue.label && newValue.name) {
                          setInputValue(`${newValue.label} - ${newValue.name} `); // Update the input value to the selected label
                        } else {
                          setInputValue("");
                        }
                      }
                    }
                  }}
                  disabled={from == "SAR"}
                  renderInput={(params) => (
                    <Box sx={{ position: "relative" }}>
                      <TextField
                        disabled={from == "SAR" ? true : false}
                        {...params}
                        placeholder={TEXT_SEARCH_JOB}
                        onBlur={() => {
                          if (data) {
                            if (inputValue == "") {
                              setClientUDFields(data?.udFieldsList || []);
                            }
                          }
                        }}
                        onChange={(e) => {
                          const newValue = e.target.value;
                          getData(newValue)
                          setInputValue(newValue);
                          const matchingOption = clientJobList?.find((option) =>
                            option?.label?.startsWith(newValue)
                          );

                          if (newValue && matchingOption) {
                            hint.current = matchingOption?.label;
                          } else {
                            hint.current = "";
                          }
                        }}
                      />
                    </Box>
                  )}
                />
              </Grid>
              <Grid size={12}>
                <Typography sx={{ margin: 0 }} variant="subtitle1" gutterBottom>
                  {TEXT_DESCRIPTION}
                </Typography>
                <TextField
                  fullWidth
                  slotProps={{
                    input: {
                      multiline: true,
                      inputComponent: "textarea"
                    }
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: "0",
                      padding: " 5px 10px"
                    },
                    "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
                      border: "none"
                    }
                  }}
                  rows={5}
                  style={{
                    backgroundColor: "#e4e4e4",
                    borderRadius: "10px"
                  }}
                  placeholder={TEXT_PROBLEM_NEEDS_DONE}
                  value={description}
                  onChange={(e) => {
                    let inputValue = e.target.value;
                    inputValue = inputValue.replace(/^[^A-Za-z0-9]+/, "");
                    setDescription(inputValue);
                  }}
                />
              </Grid>
              <Grid sx={{ gap: 2, marginTop: 2, display: "flex" }} size={12}  >
                <div
                  onClick={handleAddImage}
                  style={{
                    cursor: "pointer",
                    height: "100px",
                    minWidth: "100px",
                    border: "2px solid #e4e4e4",
                    borderRadius: "10px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}>
                  <AddIcon />
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "10px",
                    maxWidth: "100%",
                    height: "100%",
                    scrollbarWidth: "none",
                    overflow: "scroll"
                  }}>
                  {uploadedImageList?.length > 0 && (
                    <ImageMemoComponent
                      selectedClientData={selectedClientData}
                      setPictureIndex={setImageIndex}
                      setPictureViewerOpen={setPictureViewerOpen}
                      uploadedImageList={uploadedImageList}
                      handleRemoveImage={handleRemoveImage}
                    />
                  )}
                </div>
              </Grid>
            </Grid>
            <Grid>
              <ClientUDFieldComponent
                mode="edit"
                udFields={mode === "edit" ? data?.udFieldsList : clientUDFields}
                onChange={handleUDFieldChange}
              />
            </Grid>
            <Grid sx={{ marginTop: clientUDFields?.length == 0 ? 1 : 0 }}>
              <LoadingButton
                onClick={handleSafetyObservationSubmit}
                fullWidth
                disabled={!description || !selectedValue?.clientJobCodeId}
                style={{
                  marginTop: "10px",
                  background:
                    !description || !selectedValue?.clientJobCodeId
                      ? BILightGrey
                      : CLIENT_ACCENT_COLOR,
                  color: "white",
                  borderRadius: "10px"
                }}
                loadingPosition="start"
                loading={loading}
                variant="contained">
                {BUTTON_SUBMIT}
              </LoadingButton>
            </Grid>
            <input
              type="file"
              accept="image/*"
              onChange={handleImageChange}
              ref={imgRef}
              style={{ display: "none" }}
              multiple
            />
          </Stack>
        </div>
      </Modal>
      <PictureViewer
        isOpen={pictureViewerOpen}
        onClose={() => setPictureViewerOpen(false)}
        pictures={uploadedImageList?.map((item) => ({
          src: item.fileUrl ? item?.fileUrl : URL.createObjectURL(item),
          alt: ""
        }))}
        viewerIndex={imageIndex}
      />
    </>
  );
}

const ImageList = ({
  uploadedImageList,
  handleRemoveImage,
  setPictureIndex,
  setPictureViewerOpen,
  selectedClientData
}) => {
  const ImgUrl = (file) => {
    try {
      let url = URL.createObjectURL(file);
      return url;
    } catch (error) {
      return file;
    }
  };
  return uploadedImageList?.map((picture, index) => (
    <div style={{ position: "relative", height: "100px" }} key={index}>
      <img
        loading="lazy"
        onClick={() => {
          setPictureViewerOpen(true);
          setPictureIndex(index);
        }}
        src={picture?.fileUrl || ImgUrl(picture)}
        alt={"NO data"}
        style={{
          cursor: "pointer",
          width: "100px",
          height: "100px",
          borderRadius: "10px"
        }}
      />
      <IconButton
        onClick={() => handleRemoveImage(picture, index)}
        style={{
          position: "absolute",
          top: 0,
          right: 0,
          padding: "5px",
          color:
            selectedClientData?.AccentColor !== undefined &&
              selectedClientData?.AccentColor
              ? selectedClientData?.AccentColor
              : BILightGrey,
          backgroundColor: "rgba(0,0,0,0.3)"
        }}>
        <CloseIcon style={{ fontSize: "16px" }} />
      </IconButton>
    </div>
  ));
};

const ImageMemoComponent = memo(ImageList);

